import React, { useEffect, useMemo, useState } from 'react';
import { compose } from 'ramda';
import Form from 'js/components/common/Form';
import { useLocation } from 'react-router-dom';
import { Icon } from 'js/components/common/Icon';
import { Button } from 'js/components/common/Button';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { useComponentMethods } from 'js/hooks/component/useComponentMethods';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import { Reasons } from './components/Reasons';
import { Duration } from './components/Duration';
import { UNSUBSCRIBE_MARKETING, NO_DURATION } from './constants';

import style from './UnsubscribeMarketing.scss';

export const UnsubscribeMarketingBare = () => {
    const isMounted = useIsMounted();
    const { search } = useLocation();
    const [error, setError] = useState('');
    const translate = useComponentTranslations();
    const { showComponentError } = useComponentMethods();
    const [isUnsubscribed, setIsUnsubscribed] = useState(false);
    const { availablePeriods, reasons } = hooks.useUnsubscribeConfig();
    const token = new URLSearchParams(search).get('unsubscribe_token');
    const initialValues = useMemo(() => ({
        other: '',
        duration: availablePeriods[0] || NO_DURATION,
        description: reasons[0] || ''
    }), [availablePeriods, reasons]);

    const onSubmit = hooks.useOnSubmit({ token, translate, isMounted, setIsUnsubscribed, setError });

    useEffect(() => {
        if (!token) {
            showComponentError(translate('error'));
        }
    }, [showComponentError, translate, token]);

    return (
        <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
            render={({ handleSubmit, submitting, values: { description } }) => (
                <form className={style.container} onSubmit={event => event.preventDefault()}>
                    <h3 className={style.title}>{translate('title')}</h3>

                    {error && <ErrorMessage className={style.error} error={error} animate={true} />}

                    {isUnsubscribed
                        ? (
                            <div className={style.success}>
                                <Icon type="success" />
                                <span>{translate('submit.success')}</span>
                            </div>
                        )
                        : (
                            <>
                                <Duration
                                    translate={translate}
                                    availablePeriods={availablePeriods}
                                />
                                <Reasons
                                    reasons={reasons}
                                    translate={translate}
                                    description={description}
                                />
                                <Button
                                    type="button"
                                    disabled={submitting}
                                    onClick={handleSubmit}
                                    className={style.submit}
                                >
                                    {translate('submit')}
                                </Button>
                            </>
                        )
                    }
                </form>
            )}
        />
    );
};

export const UnsubscribeMarketing = compose(
    withComponent()
)(UnsubscribeMarketingBare);

componentService.registerPageComponents({ [UNSUBSCRIBE_MARKETING]: UnsubscribeMarketing });
